import { render, staticRenderFns } from "./GuppyChatEmptyView.vue?vue&type=template&id=869518dc"
import script from "./GuppyChatEmptyView.vue?vue&type=script&lang=js"
export * from "./GuppyChatEmptyView.vue?vue&type=script&lang=js"
import style0 from "./GuppyChatEmptyView.vue?vue&type=style&index=0&id=869518dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports